import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';
import type { StateReferenceDTO, StateReferencePayload } from './types';

export const useCreateStateReference = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (payload: Partial<StateReferencePayload>) => {
			try {
				const { data } = await api.post<StateReferenceDTO>('/state-reference/create', payload);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao criar referência');
			}
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ['state-references'] }),
		onError: error =>
			console.error('Erro ao criar referência:', getApiErrorMessage(error, 'Erro ao criar referência')),
	});
};
